import React from 'react';

// 模板数据
const templates = [
  {
    id: 'single-loop',
    name: '单圈手链设计模板',
    description: '适合制作单圈手链的设计草图模板',
    format: 'PDF',
    size: 'A4',
    downloadUrl: 'https://via.placeholder.com/400x300/FFB3BA/ffffff?text=单圈模板',
    image: 'https://via.placeholder.com/400x300/FFB3BA/ffffff?text=单圈模板'
  },
  {
    id: 'double-loop',
    name: '双圈手链设计模板',
    description: '适合制作双圈手链的设计草图模板',
    format: 'PDF',
    size: 'A4',
    downloadUrl: 'https://via.placeholder.com/400x300/BAFFC9/ffffff?text=双圈模板',
    image: 'https://via.placeholder.com/400x300/BAFFC9/ffffff?text=双圈模板'
  },
  {
    id: 'triple-loop',
    name: '三圈手链设计模板',
    description: '适合制作三圈手链的设计草图模板',
    format: 'PDF',
    size: 'A4',
    downloadUrl: 'https://via.placeholder.com/400x300/BAE1FF/ffffff?text=三圈模板',
    image: 'https://via.placeholder.com/400x300/BAE1FF/ffffff?text=三圈模板'
  },
  {
    id: 'multiple-strand',
    name: '多股手链设计模板',
    description: '适合制作多股手链的设计草图模板',
    format: 'PDF',
    size: 'A4',
    downloadUrl: 'https://via.placeholder.com/400x300/FFFFBA/ffffff?text=多股模板',
    image: 'https://via.placeholder.com/400x300/FFFFBA/ffffff?text=多股模板'
  },
  {
    id: 'layered',
    name: '分层手链设计模板',
    description: '适合制作分层手链的设计草图模板',
    format: 'PDF',
    size: 'A4',
    downloadUrl: 'https://via.placeholder.com/400x300/E2BAFF/ffffff?text=分层模板',
    image: 'https://via.placeholder.com/400x300/E2BAFF/ffffff?text=分层模板'
  },
  {
    id: 'crystal',
    name: '水晶手链设计模板',
    description: '适合制作水晶手链的设计草图模板',
    format: 'PDF',
    size: 'A4',
    downloadUrl: 'https://via.placeholder.com/400x300/FFC3A0/ffffff?text=水晶模板',
    image: 'https://via.placeholder.com/400x300/FFC3A0/ffffff?text=水晶模板'
  },
  {
    id: 'buddhist-beads',
    name: '佛珠手链设计模板',
    description: '适合制作佛珠手链的设计草图模板',
    format: 'PDF',
    size: 'A4',
    downloadUrl: 'https://via.placeholder.com/400x300/D7CCC8/ffffff?text=佛珠模板',
    image: 'https://via.placeholder.com/400x300/D7CCC8/ffffff?text=佛珠模板'
  },
  {
    id: 'minimalist',
    name: '简约手链设计模板',
    description: '适合制作简约手链的设计草图模板',
    format: 'PDF',
    size: 'A4',
    downloadUrl: 'https://via.placeholder.com/400x300/E0E0E0/ffffff?text=简约模板',
    image: 'https://via.placeholder.com/400x300/E0E0E0/ffffff?text=简约模板'
  },
  {
    id: 'ancient-style',
    name: '古风手链设计模板',
    description: '适合制作古风手链的设计草图模板',
    format: 'PDF',
    size: 'A4',
    downloadUrl: 'https://via.placeholder.com/400x300/FFE0B2/ffffff?text=古风模板',
    image: 'https://via.placeholder.com/400x300/FFE0B2/ffffff?text=古风模板'
  },
  {
    id: 'children',
    name: '儿童手链设计模板',
    description: '适合制作儿童手链的设计草图模板',
    format: 'PDF',
    size: 'A4',
    downloadUrl: 'https://via.placeholder.com/400x300/FFCCBC/ffffff?text=儿童模板',
    image: 'https://via.placeholder.com/400x300/FFCCBC/ffffff?text=儿童模板'
  }
];

const TemplateDownload = () => {
  // 模拟下载功能，带有用户反馈
  const handleDownload = (template) => {
    // 显示下载提示
    alert(`📥 正在下载：${template.name}（${template.format}）\n\n💡 提示：当前为模拟环境，下载的是演示图片。在实际生产环境中，将提供真实的模板文件下载。`);
    
    // 模拟下载行为
    const link = document.createElement('a');
    link.href = template.downloadUrl;
    link.download = `${template.id}.${template.format.toLowerCase()}`;
    
    // 触发点击事件开始下载
    document.body.appendChild(link);
    link.click();
    
    // 清理临时元素
    document.body.removeChild(link);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-8 text-emerald-800">
          手链设计模板下载
        </h1>
        
        {/* 说明文字 */}
        <div className="bg-white bg-opacity-80 rounded-lg p-4 mb-8 text-center text-gray-600">
          <p>当前为模拟环境，下载链接为演示用图片。在实际生产环境中，将提供真实的模板文件下载。</p>
        </div>
        
        {/* 模板列表 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {templates.map((template) => (
            <div key={template.id} className="bg-white rounded-xl shadow-lg overflow-hidden border border-green-100">
              {/* 模板图片 */}
              <div className="h-48 overflow-hidden">
                <img
                  src={template.image}
                  alt={template.name}
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                />
              </div>
              
              {/* 模板信息 */}
              <div className="p-6">
                <h2 className="text-xl font-semibold mb-2 text-emerald-700">
                  {template.name}
                </h2>
                <p className="text-gray-600 mb-4">{template.description}</p>
                
                {/* 模板详情 */}
                <div className="grid grid-cols-2 gap-2 mb-4">
                  <div className="bg-green-50 rounded-lg p-2">
                    <div className="text-xs text-gray-600">格式</div>
                    <div className="text-sm font-medium text-emerald-800">{template.format}</div>
                  </div>
                  <div className="bg-green-50 rounded-lg p-2">
                    <div className="text-xs text-gray-600">尺寸</div>
                    <div className="text-sm font-medium text-emerald-800">{template.size}</div>
                  </div>
                </div>
                
                {/* 下载按钮 */}
                <button
                  onClick={() => handleDownload(template)}
                  className="w-full px-4 py-3 bg-gradient-to-r from-emerald-500 to-teal-500 text-white rounded-lg hover:from-emerald-600 hover:to-teal-600 transition-colors duration-200 font-medium"
                >
                  下载模板
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TemplateDownload;